"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keycode = _interopRequireDefault(require("keycode"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _isActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/isActiveElement"));

var _IconArrowOpenDown = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconArrowOpenDown"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _deprecated = _interopRequireWildcard(require("@instructure/ui-utils/lib/react/deprecated"));

var _FormField = _interopRequireDefault(require("@instructure/ui-forms/lib/components/FormField"));

var _FormPropTypes = _interopRequireDefault(require("@instructure/ui-forms/lib/utils/FormPropTypes"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'dLdjY',
  template: function template(theme) {
    return "\n\n.dLdjY_bGBk{display:block;position:relative}\n\n.dLdjY_bGBk .dLdjY_fAVq{color:".concat(theme.arrowColor || 'inherit', ";display:block;inset-inline-end:").concat(theme.padding || 'inherit', ";inset-inline-start:auto;pointer-events:none;position:absolute;top:50%;transform:translateY(-50%)}\n\n[dir=ltr] .dLdjY_bGBk .dLdjY_fAVq{left:auto;right:").concat(theme.padding || 'inherit', "}\n\n[dir=rtl] .dLdjY_bGBk .dLdjY_fAVq{left:").concat(theme.padding || 'inherit', ";right:auto}\n\n.dLdjY_bGBk .dLdjY_bDLZ{-moz-appearance:none;-webkit-appearance:none;all:initial;animation:none 0s ease 0s 1 normal none running;appearance:none;backface-visibility:visible;background:transparent none repeat 0 0/auto auto padding-box border-box scroll;background:").concat(theme.background || 'inherit', ";border:medium none currentColor;border-bottom-color:").concat(theme.borderBottomColor || 'inherit', ";border-collapse:separate;border-image:none;border-left-color:").concat(theme.borderLeftColor || 'inherit', ";border-radius:0;border-radius:").concat(theme.borderRadius || 'inherit', ";border-right-color:").concat(theme.borderRightColor || 'inherit', ";border-spacing:0;border-style:").concat(theme.borderStyle || 'inherit', ";border-top-color:").concat(theme.borderTopColor || 'inherit', ";border-width:").concat(theme.borderWidth || 'inherit', ";bottom:auto;box-shadow:none;box-sizing:content-box;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:#000;color:").concat(theme.color || 'inherit', ";column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-span:1;column-width:auto;columns:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;direction:inherit;display:inline;display:block;empty-cells:show;float:none;font-family:serif;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:medium;font-stretch:normal;font-style:normal;font-variant:normal;font-weight:400;font-weight:").concat(theme.fontWeight || 'inherit', ";height:auto;hyphens:none;left:auto;letter-spacing:normal;line-height:normal;list-style:disc outside none;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:2;outline:medium none invert;outline:0.1875rem solid transparent;outline-offset:-0.5rem;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;position:static;right:auto;tab-size:8;table-layout:auto;text-align:left;text-align-last:auto;text-decoration:none;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-origin:50% 50% 0;transform-style:flat;transition:none 0s ease 0s;transition:all 0.2s ease-out;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:2;width:auto;width:100%;word-spacing:normal;z-index:auto}\n\n.dLdjY_bGBk .dLdjY_bDLZ::-ms-expand{display:none}\n\n.dLdjY_bGBk .dLdjY_bDLZ:focus{border-color:").concat(theme.focusBorderColor || 'inherit', ";outline:0.1875rem solid ").concat(theme.focusOutlineColor || 'inherit', ";outline-offset:-0.1875rem}\n\n.dLdjY_bGBk .dLdjY_bDLZ[aria-invalid],.dLdjY_bGBk .dLdjY_bDLZ[aria-invalid]:focus{border-color:").concat(theme.errorBorderColor || 'inherit', "}\n\n.dLdjY_bGBk .dLdjY_bDLZ[aria-invalid]:focus{outline-color:").concat(theme.errorOutlineColor || 'inherit', "}\n\n.dLdjY_ywdX{cursor:not-allowed;opacity:0.5;pointer-events:none}\n\n.dLdjY_doqw .dLdjY_bDLZ{-webkit-padding-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.smallArrowWidth || 'inherit', ");-webkit-padding-start:").concat(theme.padding || 'inherit', ";font-size:").concat(theme.smallFontSize || 'inherit', ";height:").concat(theme.smallHeight || 'inherit', ";line-height:").concat(theme.smallHeight || 'inherit', ";padding-bottom:0;padding-inline-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.smallArrowWidth || 'inherit', ");padding-inline-start:").concat(theme.padding || 'inherit', ";padding-top:0}\n\n[dir=ltr] .dLdjY_doqw .dLdjY_bDLZ{padding-left:").concat(theme.padding || 'inherit', ";padding-right:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.smallArrowWidth || 'inherit', ")}\n\n[dir=rtl] .dLdjY_doqw .dLdjY_bDLZ{padding-left:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.smallArrowWidth || 'inherit', ");padding-right:").concat(theme.padding || 'inherit', "}\n\n.dLdjY_doqw .dLdjY_fAVq{font-size:").concat(theme.smallArrowWidth || 'inherit', "}\n\n.dLdjY_ycrn .dLdjY_bDLZ{-webkit-padding-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.mediumArrowWidth || 'inherit', ");-webkit-padding-start:").concat(theme.padding || 'inherit', ";font-size:").concat(theme.mediumFontSize || 'inherit', ";height:").concat(theme.mediumHeight || 'inherit', ";line-height:").concat(theme.mediumHeight || 'inherit', ";padding-bottom:0;padding-inline-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.mediumArrowWidth || 'inherit', ");padding-inline-start:").concat(theme.padding || 'inherit', ";padding-top:0}\n\n[dir=ltr] .dLdjY_ycrn .dLdjY_bDLZ{padding-left:").concat(theme.padding || 'inherit', ";padding-right:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.mediumArrowWidth || 'inherit', ")}\n\n[dir=rtl] .dLdjY_ycrn .dLdjY_bDLZ{padding-left:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.mediumArrowWidth || 'inherit', ");padding-right:").concat(theme.padding || 'inherit', "}\n\n.dLdjY_ycrn .dLdjY_fAVq{font-size:").concat(theme.mediumArrowWidth || 'inherit', "}\n\n.dLdjY_cMDj .dLdjY_bDLZ{-webkit-padding-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.largeArrowWidth || 'inherit', ");-webkit-padding-start:").concat(theme.padding || 'inherit', ";font-size:").concat(theme.largeFontSize || 'inherit', ";height:").concat(theme.largeHeight || 'inherit', ";line-height:").concat(theme.largeHeight || 'inherit', ";padding-bottom:0;padding-inline-end:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.largeArrowWidth || 'inherit', ");padding-inline-start:").concat(theme.padding || 'inherit', ";padding-top:0}\n\n[dir=ltr] .dLdjY_cMDj .dLdjY_bDLZ{padding-left:").concat(theme.padding || 'inherit', ";padding-right:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.largeArrowWidth || 'inherit', ")}\n\n[dir=rtl] .dLdjY_cMDj .dLdjY_bDLZ{padding-left:calc(").concat(theme.padding || 'inherit', "*2 + ").concat(theme.largeArrowWidth || 'inherit', ");padding-right:").concat(theme.padding || 'inherit', "}\n\n.dLdjY_cMDj .dLdjY_fAVq{font-size:").concat(theme.largeArrowWidth || 'inherit', "}");
  },
  'root': 'dLdjY_bGBk',
  'arrow': 'dLdjY_fAVq',
  'select': 'dLdjY_bDLZ',
  'disabled': 'dLdjY_ywdX',
  'small': 'dLdjY_doqw',
  'medium': 'dLdjY_ycrn',
  'large': 'dLdjY_cMDj'
};
var Select = (_dec = (0, _deprecated.default)('5.0.0', null, (0, _deprecated.changedPackageWarning)('ui-core', 'ui-forms')), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Select, _Component);

  function Select(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Select);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Select).call(this));

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      if (typeof onChange === 'function') {
        onChange(e);
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          disabled = _this$props2.disabled;
      var keycodes = [_keycode.default.codes.space, _keycode.default.codes.up, _keycode.default.codes.down];

      if (disabled && (keycodes.includes(e.keyCode) || e.keyCode >= 48 && e.keyCode <= 57 || // 0 - 9
      e.keyCode >= 65 && e.keyCode <= 90 || // A - Z
      e.keyCode >= 96 && e.keyCode <= 105 // numpad 0 - 9
      )) {
        e.preventDefault();
        return;
      }

      if (typeof onKeyDown === 'function') {
        onKeyDown(e);
      }
    };

    _this._defaultId = (0, _uid.default)('Select');
    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "focus",
    value: function focus() {
      this._select.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _classes,
          _this2 = this;

      var _this$props3 = this.props,
          size = _this$props3.size,
          children = _this$props3.children,
          width = _this$props3.width,
          layout = _this$props3.layout,
          selectRef = _this$props3.selectRef,
          onBlur = _this$props3.onBlur,
          required = _this$props3.required,
          disabled = _this$props3.disabled,
          value = _this$props3.value,
          defaultValue = _this$props3.defaultValue;
      var props = (0, _passthroughProps.omitProps)(this.props, Select.propTypes);
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[size], size), (0, _defineProperty2.default)(_classes, styles.disabled, disabled), _classes);
      var style = width ? {
        width: width
      } : null;
      return _react.default.createElement(_FormField.default, Object.assign({}, (0, _passthroughProps.pickProps)(this.props, _FormField.default.propTypes), {
        layout: layout,
        id: this.id
      }), _react.default.createElement("span", {
        className: (0, _classnames.default)(classes),
        style: style
      }, _react.default.createElement("select", Object.assign({}, props, {
        id: this.id,
        ref: function ref(select) {
          _this2._select = select;

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          selectRef.apply(_this2, [select].concat(args));
        },
        value: value,
        defaultValue: defaultValue,
        onBlur: onBlur,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        className: styles.select,
        required: required,
        "aria-required": required,
        "aria-invalid": this.invalid ? 'true' : null,
        "aria-disabled": disabled ? 'true' : null,
        disabled: disabled
      }), children), _react.default.createElement(_IconArrowOpenDown.default, {
        className: styles.arrow
      })));
    }
  }, {
    key: "id",
    get: function get() {
      return this.props.id || this._defaultId;
    }
  }, {
    key: "invalid",
    get: function get() {
      return this.props.messages && this.props.messages.findIndex(function (message) {
        return message.type === 'error';
      }) >= 0;
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _isActiveElement.default)(this._select);
    }
  }, {
    key: "value",
    get: function get() {
      return this._select.value;
    }
  }]);
  Select.displayName = "Select";
  return Select;
}(_react.Component), _class2.propTypes = {
  /**
  * Children must be option tags.
  */
  children: _uiPropTypes.Children.oneOf(['option']),
  label: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,

  /**
  * object with shape: `{
  * text: PropTypes.string,
  * type: PropTypes.oneOf(['error', 'hint', 'success', 'screenreader-only'])
  *   }`
  */
  messages: _propTypes.default.arrayOf(_FormPropTypes.default.message),
  id: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  layout: _propTypes.default.oneOf(['stacked', 'inline']),
  required: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  width: _propTypes.default.string,

  /**
  * a function that provides a reference to the actual select element
  */
  selectRef: _propTypes.default.func,

  /**
  * value to set on initial render
  */
  defaultValue: _propTypes.default.string,

  /**
  * the selected value (must be accompanied by an `onChange` prop)
  */
  value: (0, _uiPropTypes.controllable)(_propTypes.default.string),

  /**
  * when used with the `value` prop, the component will not control its own state
  */
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onKeyDown: _propTypes.default.func
}, _class2.defaultProps = {
  required: false,
  width: void 0,
  inline: false,
  type: 'text',
  size: 'medium',
  layout: 'stacked',
  messages: [],
  disabled: false,
  selectRef: function selectRef(select) {},
  children: null,
  id: void 0,
  value: void 0,
  defaultValue: void 0,
  onChange: void 0,
  onBlur: void 0,
  onKeyDown: void 0
}, _temp)) || _class) || _class);
var _default = Select;
exports.default = _default;